import React from 'react';
import { columns } from './columns';
import Table from '../../../../components/_table/Table/Table';
import { getCouponProductValidationClassName } from '../../../../lib/utils/couponUtils';
import { COUPON_PRODUCT_ITEM_LIST_FILTER_OPTION_MODEL } from '../../../../store/modules/coupon/models';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import './CouponDetailProductItemList.scss';

const CouponDetailProductItemList = (props) => {
  const {
    couponProductLinkList,
    mainProductCategorySelectList,
    subProductCategorySelectList,
    filterOption,
    getList,
    pagination,
    discountType,
    discountAmount,
    maxDiscountPrice,
    getProductSubCategoryList,
  } = props;

  return (
    <div className="coupon-detail-product-item-content">
      <div className="coupon-detail-product-item-text">
        주황색이 된 상품은 쿠폰 최소 금액 미달 상품으로, 쿠폰 사용이 불가능합니다
      </div>

      <Table
        className="coupon-detail-product-item-list"
        columns={(utils) =>
          columns({
            ...utils,
            mainProductCategorySelectList,
            subProductCategorySelectList,
            getProductSubCategoryList,
            isFilter: true,
          })
        }
        rowKey={(record) => record.id}
        list={couponProductLinkList}
        rowClassName={(record) =>
          getCouponProductValidationClassName(discountType, record.salesPrice, discountAmount, maxDiscountPrice)
        }
        initialOption={{
          filterOption: COUPON_PRODUCT_ITEM_LIST_FILTER_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
        }}
        filterOption={filterOption}
        pagination={pagination}
        size="small"
        scroll={{ x: true }}
        bordered={true}
        getList={(option) =>
          getList({
            ...option,
          })
        }
      />
    </div>
  );
};

export default CouponDetailProductItemList;
